import * as React from 'react'
import classNames from 'classnames'

import type { Image } from 'types'
import HeadlineThree from '../Headlines/HeadlineThree'
import Paragraph from 'content-components/_Primatives/Paragraph'
import { InlineImage } from 'content-components/_Primatives/Images'
import Ruler from '../Ruler'
import YouTube from '../YouTube'
import Link from 'content-components/_Primatives/Link'

import style from './style.scss'

interface BaseProps {
  className?: string
  captionText?: string
  captionTitle?: string
  headlineText?: string
  imageSizes?: string
  link?: {
    target: string
    url: string
  }
  isGradient?: boolean
}

interface VideoProps extends BaseProps {
  type: 'video'
  youtubeVideoId: string
}

interface ImageProps extends BaseProps {
  image: Image
  type?: 'image'
}

export type Props = VideoProps | ImageProps

function ImageCaption(props: Props) {
  const { captionText, captionTitle, className, headlineText, link } = props

  return (
    <div className={classNames(style.wrapper, className)}>
      {headlineText && (
        <HeadlineThree className={style.headline}>{headlineText}</HeadlineThree>
      )}

      {<Media {...props} />}

      {captionTitle && (
        <Link className={style.captionTitle} {...link}>
          {captionTitle}
        </Link>
      )}

      {captionText && (
        <Paragraph className={style.captionText} small>
          {captionText}
        </Paragraph>
      )}
      {captionTitle && !captionText && <Ruler small />}
    </div>
  )
}

function Media(props: Props) {
  switch (props.type) {
    case 'video': {
      const { youtubeVideoId } = props
      return <YouTube className={style.video} videoId={youtubeVideoId} />
    }

    default: {
      const { image, isGradient, imageSizes, link } = props
      return (
        <Link aria-label={props.captionTitle} {...link}>
          <InlineImage
            className={style.image}
            gradient={isGradient}
            image={image}
            sizes={imageSizes}
          />
        </Link>
      )
    }
  }
}

export default ImageCaption
